export const EsLocale = {
    page: {
        txtTitle: 'UNVOX | Elimina voces al instante',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'logo de unvox',
        },
        action: {
            txtBack: 'Atrás',
            txtRetry: 'Reintentar',
            txtStartOver: 'Empezar de nuevo',
        },
        job: {
            txtCheckingStatus: 'Comprobando estado del trabajo',
            txtIdLabel: 'ID del trabajo',
        },
        footer: {
            linkPrivacyPolicy: 'Política de privacidad',
            linkTerms: 'Términos',
            linkRefunds: 'Reembolsos',
            linkSupport: 'Soporte',
            txtAllRightsReserved: 'Todos los derechos reservados.',
            txtBugReportsAndFeatures: 'Reportes de errores y solicitudes de funciones',
        },
        share: {
            title: 'UNVOX | Elimina voces de canciones con un clic',
            text: 'Convierte fácilmente tus canciones favoritas en instrumentales listas para karaoke.',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'Eliminación de voz con un clic',
            txtHeroSubtitle: 'Instrumentales instantáneas desde tu pista o directamente desde YouTube',
            txtInputTypeLabel: 'Tipo de entrada',
            txtInputTypeFile: 'Subir archivo de audio',
            txtInputTypeYoutube: 'Enlace de YouTube',
            txtInputFilePick: 'Elegir archivo',
            txtInputFileSub: 'Formatos de audio comunes ({{formats}}), hasta {{size}} MB.',
            txtPreviewAction: 'Eliminar voces',
            txtPreviewFailed: 'Ocurrió un error desconocido. Inténtalo de nuevo más tarde.',
            txtUploadSelectFile: 'Aún no se eligió ningún archivo',
            txtYoutubeLabel: 'URL de YouTube',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Pega un enlace público de YouTube.',
            txtYoutubeMissing: 'Pega una URL de YouTube.',
            txtYoutubeInvalid: 'Ingresa una URL de YouTube válida.',
            txtYoutubeTooLong: 'Este video dura más de 15 minutos. Elige uno más corto.',
            txtCheckoutUploadFailed: 'La carga falló. Inténtalo de nuevo.',
            txtUploadMissing: 'Elige un archivo antes de subirlo.',
            txtFileTypeInvalid: 'Tipo de archivo no compatible. Sube un archivo de audio (por ejemplo, {{formats}}).',
            txtFileTooLarge: 'El archivo es demasiado grande. El tamaño máximo es {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'No se pudo crear la vista previa',
            txtUnavailableBody: 'Ocurrió un error desconocido. Inténtalo de nuevo más tarde.',
            txtPreparingTitle: 'Preparando vista previa',
            txtPreparingBody: 'Esto puede tardar hasta 2 minutos',
        },
        payment: {
            txtUnavailableTitle: 'No se pudo crear la vista previa',
            txtUnavailableBody: 'Ocurrió un error desconocido. Inténtalo de nuevo más tarde.',
            txtPreparingTitle: 'Preparando vista previa',
            txtCheckoutCancelledBody: 'No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras.',
            txtTrackPreviewLabel: 'Vista previa de la pista',
            txtTrackPreviewHelper: 'Esta vista previa es un clip de 15 segundos de tu pista para evaluación',
            txtEmailLabel: 'Correo electrónico',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'Usaremos esto para enviarte tu enlace de descarga.',
            txtCheckoutAction: 'Eliminar voces por solo {{price}}',
            txtCheckoutActionFallback: 'Eliminar voces',
            txtCheckoutFailed: 'No se pudo iniciar el pago. Inténtalo de nuevo.',
            txtInvalidEmail: 'Ingresa un correo electrónico válido.',
        },
        processing: {
            txtMissingTitle: 'Falta el id del trabajo',
            txtMissingBody: 'Esta página necesita un id de trabajo. Inicia una nueva vista previa.',
            txtMissingAction: 'Volver a subir',
            txtStatusFailed: 'No se pudo obtener el estado del trabajo. Inténtalo de nuevo.',
            txtErrorTitle: 'Algo salió mal',
            txtSupportAction: 'Contactar soporte',
            txtConfirmingTitle: 'Confirmando pago',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Buscando actualizaciones',
            txtWorkingTitle: 'Procesando tu pista completa',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Iniciar otro',
            txtReadyTitle: 'Descarga lista',
            txtReadyBody: 'Tu instrumental está listo para descargar.',
            txtDownloadAction: 'Descargar',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Iniciar otro',
        },
        invalidJob: {
            txtTitle: 'Id de trabajo inválido',
            txtBody: 'No se pudo encontrar ese trabajo. Inicia una nueva carga.',
            txtAction: 'Empezar de nuevo',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Soporte',
            txtTitle: 'Contactar soporte',
            txtLastUpdatedLabel: 'Última actualización',
            txtLastUpdatedDate: '9 de febrero de 2026',
            txtSectionEmailTitle: 'Correo electrónico',
            txtSectionEmailBodyPrefix: 'Envíanos un correo a',
            txtSectionIncludeJobIdTitle: 'Incluye tu id de trabajo',
            txtSectionIncludeJobIdBody: 'Incluye tu id de trabajo para que podamos ubicarlo rápidamente. Si pagaste, incluye el correo usado en el pago.',
            txtSectionBugReportsTitle: 'Reportes de errores',
            txtSectionBugReportsBody: 'También puedes enviar reportes de errores y solicitudes de funciones desde el enlace en el pie de página.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Comentarios',
            txtTitle: 'Reportes de errores y solicitudes de funciones',
            txtSubtitle: 'UNVOX está en una etapa temprana. Si algo se siente mal o tienes una idea, envíala. Los reportes claros son la forma más rápida de enviar correcciones.',
            txtWhatToIncludeTitle: 'Qué incluir',
            txtChecklistExpectedVsActual: 'Qué esperabas vs qué pasó',
            txtChecklistSteps: 'Pasos para reproducir (1, 2, 3)',
            txtChecklistBrowserOs: 'Tu navegador y sistema operativo',
            txtChecklistJobId: 'ID del trabajo (si involucró una carga)',
            txtTipTitle: 'Consejo',
            txtTipBody: 'Si nos escribes por correo, puedes responder directamente al email de entrega que recibiste y pegar la plantilla.',
            txtTemplateTitle: 'Plantilla para copiar y pegar',
            txtTemplateBody: 'Reporte de error / Solicitud de función\n\nTipo: error | función\nResumen:\n\nDetalles:\n- Qué pasó:\n- Qué esperabas:\n- Pasos para reproducir:\n  1.\n- Navegador/SO:\n\nOpcional:\n- ID del trabajo:\n- URL de YouTube:\n- Captura/video:\n',
            txtTemplatePageLabel: 'Página',
            txtTemplateUserAgentLabel: 'Agente de usuario',
            txtCopyActionIdle: 'Copiar plantilla',
            txtCopyActionCopied: 'Copiado',
            txtCopyActionFailed: 'Error al copiar',
            txtCopyHelpFailed: 'El acceso al portapapeles fue bloqueado. Igual puedes seleccionar el texto de arriba y copiarlo manualmente.',
            txtCopyHelpIdle: 'Nada aquí se envía automáticamente. Esta página solo te ayuda a formatear un buen reporte.',
        },
    },
};
